<template>
  <div
    :class="[
      'wrapper dropdown-wrapper dropdown-border-solo',
      (iconOnly || menuItem) ? 'icon-only-view' : '',
    ]">
    <!-- text field -->
    <ProductCellFieldText
      v-if="!iconOnly && !menuItem"
      :value="value"
      :is-expanded-mode="isExpandedMode"
      :disabled-edit-mode="disabledEditMode"
      :product-hint="productHint"
      @emitChange="emitChange" />

    <!-- product reference dialog -->
    <app-dialog
      v-if="showAddIcon"
      v-model="dialog"
      :close-on-content-click="false"
      :transition="false"
      :value.sync="dialog"
      content-class="sourcery__dialog"
      origin="right"
      overlay-color="black"
      overlay-opacity="0.75">
      <v-card>
        <v-card-title>
          <div class="d-flex align-center">
            {{ columnTitle }}
          </div>
          <span
            v-if="$vuetify.breakpoint.mdAndDown"
            class="sourcery__icon-wrapper black"
            @click="dialog = false">
            <v-icon
              color="white"
              size="15">
              mdi-close
            </v-icon>
          </span>
        </v-card-title>
        <v-card-text class="custom-fixed-scroll">
          <FieldProductAutocomplete
            :col="col"
            :created-product="createdProduct"
            :dialog="dialog"
            :multiple="isMultipleField"
            :value="value"
            @change="selectProduct"
            @setStatusDialog="setStatusDialog" />
        </v-card-text>
      </v-card>

      <!-- activator for the dialog -->
      <template
        v-if="iconOnly || !isExpandedMode"
        #activator="{ on }">
        <div @click="openWindow($event,on)">
          <v-icon
            color="green"
            :class="[
              'v-dropdown__custom--add-icon',
              iconOnly ? '' : 'mr-2 mb-3',
            ] ">
            mdi-plus-circle
          </v-icon>
        </div>
      </template>
      <template
        v-else-if="menuItem"
        #activator="{ on }">
        <span @click="openWindow($event, on)">
          <v-icon size="16">
            mdi-plus-circle
          </v-icon>Add Product Reference
        </span>
      </template>

      <!-- floating btn to close the dialog -->
      <AppDialogCloser @click="dialog = false" />
    </app-dialog>

    <slot
      name="previewDialog"
      :selectedColumnOrder="selectedColumnOrder"
      :selectedRefFields="selectedRefFields"
      :selectRefFields="selectRefFields"
      :dialog="dialogForRefFields"
      :item="item"
      :columnTitle="columnTitle"
      :manageDialog="manageDialog" />

    <!-- dialog to create a new product -->
    <CollectionsCreateProductDialog
      :can-scrape-product="true"
      :status-dialog.sync="statusDialogCreateProduct"
      :is-source-library-id="isSourceLibraryId"
      :is-status-dialog-from-state="false"
      :is-allow-comparison="false"
      :prop-library-id="sourceLibraryId"
      @savedProduct="savedProduct" />
  </div>
</template>
<script>
import {
  mapState, mapGetters, mapMutations,
} from 'vuex';

import productHeaders from '@/constants/productHeaders';

import AppDialogCloser from '@/components/App/AppDialogCloser';
import CollectionsCreateProductDialog from '@/components/Collections/CollectionsCreateProductDialog';
import FieldProductAutocomplete from '../ProductCellFieldProductAutocomplete';
import ProductCellFieldText from '@/components/Product/ProductCell/ProductCellFieldProduct/ProductCellFieldText';

import EditModeChild from '@/mixins/EditModeChildComponent';
import GetDataForProductPreview from '@/mixins/GetDataForProductPreview';

export default {
  name: 'ProductCellFieldProductBasic',
  components: {
    AppDialogCloser,
    CollectionsCreateProductDialog,
    FieldProductAutocomplete,
    ProductCellFieldText,
  },
  mixins: [EditModeChild, GetDataForProductPreview],
  props: {
    borderedCell: {
      type: Boolean,
      default: false,
    },
    disabledEditMode: {
      type: Boolean,
      default: false,
    },
    hasAccessEditor: {
      type: Boolean,
      default: true,
    },
    header: {
      type: Object,
      required: true,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    isExpandedMode: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      required: true,
    },
    menuItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogForRefFields: false,
      statusDialogCreateProduct: false,
      selectedProduct: null,
      createdProduct: {
      },
    };
  },
  computed: {
    ...mapState('ProjectDetailsTableSchedule', ['availReferenceFields']),
    ...mapState('ProjectDetails', ['detailProjectData']),
    ...mapGetters('UserProfile', ['isUnsuccessfulPayment']),
    ...mapGetters('Collections', ['selectedColumnOrder']),
    ...mapGetters('FeatureFlags', [
      'addTextNoteToEqualField',
    ]),
    ...mapGetters({
      getDefaultLibraryId: 'Libraries/getDefaultLibraryId',
      isVersionMode: 'ProjectVersions/isVersionMode',
    }),
    isSourceLibraryId() {
      return Boolean(this.detailProjectData?.sourceLibraryId);
    },
    sourceLibraryId() {
      return this.detailProjectData?.sourceLibraryId || this.getDefaultLibraryId;
    },
    selectedRefFields() {
      const fields = this.value?.fields;
      // return fields?.length ? fields : this.availReferenceFields;
      return fields?.length ? fields : this.selectedColumnOrder;
    },
    showAddIcon() {
      const { disabledEditMode, isVersionMode } = this;
      return !disabledEditMode && !isVersionMode && !this.isUnsuccessfulPayment;
    },
    productHint() {
      const { isMultipleField, isSourceLibraryId, header, addTextNoteToEqualField: flag } = this;
      if (isMultipleField && !flag) {
        return '';
      }
      const { hint, hintWithSourceLibrary } = header?.column || {
      };
      if (!isSourceLibraryId) return hint;
      return hintWithSourceLibrary;
    },
    columnTitle() {
      const { header, item } = this;
      let title = `${header?.value}`;
      const typeValue = item[productHeaders.TYPE_DESIGNATION];
      if (typeValue && typeValue !== '\b') {
        title = `${typeValue} - ${title}`;
      }
      return title;
    },
    isMultipleField() {
      return this.col !== 'Product Reference';
    },
    dialog: {
      get() {
        return this.editMode;
      },
      set(val) {
        this.setEditMode(val);
      },
    },
  },
  watch: {
    dialogForRefFields(val) {
      if (!val) {
        this.setProductToUpdate(null);
        this.setCollectionsSchema(null);
      }
    },
  },
  methods: {
    ...mapMutations('Collections', ['setProductToUpdate', 'setCollectionsSchema']),
    setStatusDialog(val) {
      this.statusDialogCreateProduct = val;
    },
    // it's method triggering for a watcher in child component
    savedProduct(val) {
      this.createdProduct = val;
    },
    openWindow(e, on) {
      e.stopPropagation();
      if (!this.hasAccessEditor) {
        this.$emit('messagesNoHasAccessEditor');
      } else {
        on.click(e);
      }
    },
    async selectRefFields(data) {
      if (this.value?.id) {
        const response = await this.$openConfirm({
          text: 'This action will replace/overwrite all information contained in this schedule item - Do you wish to proceed?',
        });
        if (!response) {
          return;
        }
      }
      this.updateCell(this.selectedProduct, data);
    },
    manageDialog(val) {
      this.dialogForRefFields = val;
    },
    selectProduct(selected) {
      const { isMultipleField: multiple } = this;
      if (!multiple) {
        this.dialogForRefFields = true;
        this.selectedProduct = selected;
        this.getDataForProductPreview();
      } else {
        this.dialogForRefFields = true;
        this.selectedProduct = selected;
        this.getDataForProductPreview();
      }
    },
    updateCell(selected, fields) {
      const { isMultipleField: multiple } = this;
      const value = {
        [multiple ? 'values' : 'value']: !multiple ? JSON.stringify({
          id: selected.id,
          title: selected.title,
          fields,
          collectionID: selected.collection,
        }) : [...selected.map(({ id, title }) => JSON.stringify({
          id,
          title,
        }))],
      };
      this.dialog = false;
      this.dialogForRefFields = false;
      this.emitChange(value);
    },
    emitChange(value) {
      if (!this.hasAccessEditor) {
        this.$emit('messagesNoHasAccessEditor');
      } else
        this.$emit('change', value);
    },
  },
};
</script>
<style scoped lang="scss">
.dropdown-wrapper {
  &__hint-text {
    font-size: 10px;
    font-weight: 400;
  }
}

.custom-fixed-scroll {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.v-dropdown__custom--add-icon {
  position: absolute;
  cursor: pointer;
  bottom: 0;
  right: 0;
}
.v-dropdown__custom--add-icon {
  border-radius: .25rem;
  background-clip: text;
}
.sticky-search {
  position: sticky;
  top: 0;
  z-index: 1;
}
.v-card {
  .dropdown-border-solo {
    line-height: 100%;
    padding: 0 5px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 40px;
    background-color: var(--v-lightGrey-base);
  }
  .dropdown-border {
    padding-top: 16px;
    padding: 10px;
    min-height: 64px;
    border-radius: 48px;
    border: 1px solid black;
  }
  .v-dropdown__custom--add-icon {
    position: absolute;
    cursor: pointer;
    bottom: 21px;
    right: 20px;
  }

  .icon-only-view {
    background: none;
    .v-dropdown__custom--add-icon {
      position: static;
    }
  }
}
</style>
